import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import { useRole } from 'components/Hooks/UserHooks';
import { useFormik } from 'formik';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
// Import React FilePond
import EditorCustom from 'components/Common/EditorCustom';
import LabelWrapper from 'components/Common/LabelWrapper';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond/dist/filepond.min.css';
import { checkCurrentUsageNews, createPost, postCreateUsingAINews } from 'store/thunks';
import SpinnerScreen from '../../Components/SpinnerScreen';
import BoxImageSearch from 'pages/News/Components/BoxImageSearch';
import Hashtag from 'components/Common/Hashtag';
import TooltipCustom from 'components/Common/TooltipCustom';
import IconMagic from 'pages/ImageRepository/Icons/IconMagic';
import DropdownOption from 'components/Common/DropdownOption';
import { UPLOAD_ACTION, WEBSITE_POST_OPTIONS } from 'helpers/constans';

export interface Tag {
    id: string;
    text: string;
}

const FILE_SIZE = 10 * 1024 * 1024; // 10MB
const SUPPORTED_FORMATS = [
    'application/pdf', // .pdf
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
];

const ModalPostArticle = ({
    isOpen,
    onCloseClick,
    onReloadListNews,
}: any) => {

    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();
    const navigate = useNavigate();

    const WEBSITE_POST_OPTIONS_LANG = WEBSITE_POST_OPTIONS?.map((item: any) => ({
        value: item?.value,
        label: t(item?.label),
    }));

    const MAX_CHAR_COUNT = 7000;

    const fileInputRef = useRef<any>(null);
    const modalBodyInnerRef = useRef<any>(null);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const refContentNews = useRef<any>(null);

    const [articleGeneration, setArticleGeneration] = useState<any>(null);

    const [title, setTitle] = useState<any>('');
    const [content, setContent] = useState<any>('');

    const [currentUsageNews, setCurrentUsageNews] = useState<number>(0);
    const [isOpenUseGeneration, setIsOpenUseGeneration] = useState<boolean>(false);

    const [isOpenMessCheck, setIsOpenMessCheck] = useState<boolean>(false);

    const [charCount, setCharCount] = useState(0);

    const handleSubmit = async (values: any) => {
        try {
            setIsLoading((_prev) => true);
            const data = {
                author: values?.author || '',
                password: values?.password || '',
                website: values?.website?.value || '',
                category_id: values?.category_id || '',
                title: values?.title || '',
                content: values?.content || '',
            };
            const response: any = await createPost(data);
            setIsLoading((_prev) => false);
            if (response?.code === 200) {
                onReloadListNews && onReloadListNews();
                toast(
                    `${t("The process has been completed.")}`,
                    CONFIG_OPTION_TOAST_NORMAL
                );
            } else {
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        author: Yup.string().nullable(),
        password: Yup.string().nullable(),
        website: Yup.object().shape({
            value: Yup.string(),
            label: Yup.string(),
        }),
        category_id: Yup.string().required(`${t("This is required")}`),
        title: Yup.string().required(`${t("This is required")}`),
        content: Yup.string().required(`${t("This is required")}`),
    });

    const formik = useFormik({
        initialValues: {
            author: '',
            password: '',
            website: WEBSITE_POST_OPTIONS_LANG[0],
            category_id: '',
            title: '',
            content: '',
        },
        validationSchema: validationSchema,
        onSubmit: handleSubmit,
    });

    const handleClose = () => {
        onCloseClick && onCloseClick();
        formik?.setFieldValue('author', '');
        formik?.setFieldValue('password', '');
        formik?.setFieldValue('website', WEBSITE_POST_OPTIONS_LANG[0]);
        formik?.setFieldValue('category_id', '');
        formik?.setFieldValue('title', '');
        formik?.setFieldValue('content', '');
        setArticleGeneration(null);
        setTimeout(() => {
            formik?.setErrors({});
        }, 500);
    };

    const handleGeneratePassword = () => {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
        let password: string = "";

        for (let i = 0; i < 10; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            password += characters[randomIndex];
        }
        formik.setFieldValue("password", password);
    };

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                formik?.setErrors({});
            }, 300);
        }
    }, [isOpen]);

    return (
        <React.Fragment>
            <Modal
                isOpen={!!isOpen}
                centered={true}
                size="xl"
                toggle={handleClose}
                keyboard={true}
                className="modal-fullscreen-"
            >
                <ModalHeader toggle={handleClose} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    {t('Button Create Post')}
                </ModalHeader>
                <ModalBody className="">
                    <form onSubmit={formik.handleSubmit}>
                        <Row>
                            <Col sm={6} md={6} lg={3} xl={3} className='mt-3 mt-md-1'>
                                <LabelWrapper label={t('Website')} isShow={true} isRequired={true}>
                                    <DropdownOption
                                        name="website"
                                        dataList={WEBSITE_POST_OPTIONS_LANG || []}
                                        placeholder={`${t("Website")}...`}
                                        className="dropdown-status-rounded z-hight"
                                        classNamePrefix="name-prefix"
                                        initialValue={formik?.values?.website || null}
                                        onChangeSelect={(e: any) => formik?.setFieldValue('website', e)}
                                        isHasOptionAll={false}
                                    />
                                </LabelWrapper>
                            </Col>
                            <Col sm={6} md={6} lg={3} xl={3} className='mt-3 mt-md-1'>
                                <LabelWrapper label={t('Category')} isShow={true} isRequired={true}>
                                    <Input
                                        type="text"
                                        name="category_id"
                                        className="form-control search"
                                        placeholder={`${t('Category')}...`}
                                        value={formik?.values?.category_id}
                                        onChange={(e) => formik?.setFieldValue('category_id', e.target.value)}
                                    />
                                </LabelWrapper>
                                {formik.touched.category_id && formik.errors.category_id ? (
                                    <div className="text-danger mt-1">{formik.errors.category_id}</div>
                                ) : null}
                            </Col>
                            <Col sm={6} md={6} lg={3} xl={3} className='mt-3 mt-lg-1'>
                                <LabelWrapper label={t('Author')} isShow={true} isRequired={false}>
                                    <Input
                                        type="text"
                                        name="author"
                                        className="form-control search"
                                        placeholder={`${t('Author')}...`}
                                        value={formik?.values?.author}
                                        onChange={(e) => formik?.setFieldValue('author', e.target.value)}
                                    />
                                </LabelWrapper>
                                {formik.touched.author && formik.errors.author ? (
                                    <div className="text-danger mt-1">{formik.errors.author}</div>
                                ) : null}
                            </Col>
                            <Col sm={6} md={6} lg={3} xl={3} className='mt-3 mt-lg-1'>
                                <LabelWrapper label={t('Password')} isShow={true} isRequired={false}>
                                    <div className="position-relative">
                                        <Input
                                            name="password"
                                            type={"text"}
                                            className="form-control"
                                            id="password"
                                            autoComplete="off"
                                            placeholder={`${t('Password')}...`}
                                            value={formik?.values?.password}
                                            onChange={(event: any) => formik.setFieldValue('password', event?.target?.value)}
                                        />
                                        <div className="d-flex position-absolute end-0 top-0" style={{ listStyle: 'none' }}>
                                            <TooltipCustom
                                                title={t('Generate Password')}
                                            >
                                                <button className="btn btn-link text-decoration-none text-muted" onClick={() => handleGeneratePassword()} type="button"><i className="ri ri-refresh-line align-middle"></i></button>
                                            </TooltipCustom>
                                        </div>
                                    </div>
                                </LabelWrapper>
                                {formik.touched.password && formik.errors.password ? (
                                    <div className="text-danger mt-1 fs-14">{formik.errors.password}</div>
                                ) : null}
                            </Col>
                            <Col sm={12} lg={12} xl={12} className='mb-3 mb-lg-0 mt-3'>
                                <div className="position-relative p-3 px-2" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '8px' }} ref={modalBodyInnerRef}>
                                    <span className="position-absolute text-primary px-2" style={{ top: 0, left: '10px', transform: 'translateY(-50%)', backgroundColor: 'var(--vz-secondary-bg)' }}>{t('Post')}</span>
                                    <div className="position-relative d-flex flex-column justify-content-between mb-0 box-content-ai-article-generation" style={{ height: 'calc(100dvh - 320px)', minHeight: '400px' }}>
                                        <LabelWrapper label={t('Title')} isShow={true} isRequired={true} className="mt-1">
                                            <Input
                                                name="title"
                                                type="text"
                                                className={`form-control px-3 mb-0 py-1`}
                                                placeholder={`${t('Title')}...`}
                                                rows={1}
                                                style={{ width: '100%', minHeight: '38px', fontWeight: '500' }}
                                                value={formik?.values?.title || ''}
                                                onChange={(event: any) => {
                                                    const input = event.target.value;
                                                    formik?.setFieldValue('title', input);
                                                }}
                                                autoComplete="off"
                                            />
                                        </LabelWrapper>
                                        {formik.touched.title && formik.errors.title ? (
                                            <div className="text-danger mt-1 ms-1 fs-14">{formik.errors.title}</div>
                                        ) : null}
                                        <LabelWrapper label={t('Content')} isShow={true} isRequired={true} className="flex-grow-1 mt-3">
                                            <Input
                                                name="content"
                                                type="textarea"
                                                className={`form-control px-3 mb-0 py-1`}
                                                placeholder={`${t('Content')}...`}
                                                // rows={10}
                                                style={{ width: '100%', minHeight: '38px', height: '100%' }}
                                                value={formik?.values?.content || ''}
                                                onChange={(event: any) => {
                                                    const input = event.target.value;
                                                    formik?.setFieldValue('content', input);
                                                }}
                                                autoComplete="off"
                                            />
                                        </LabelWrapper>
                                        {formik.touched.content && formik.errors.content ? (
                                            <div className="text-danger mt-1 ms-1 fs-14">{formik.errors.content}</div>
                                        ) : null}
                                        {/* <SpinnerScreen isShow={isLoading || articleGeneration == null} isAnimationText={isLoading} textLoading={isLoading ? "AI is generating the article!" : "Try generating an article with AI!"} className="duration-4" style={{ borderRadius: 'var(--vz-border-radius)' }} /> */}
                                    </div>
                                    <div className="text-end mt-2 px-0 d-flex justify-content-end align-items-end " style={{ minHeight: '48px' }}>
                                        <div>
                                            <button
                                                className="btn btn-success flex-grow-1 fs-14"
                                                color="light"
                                                type="submit"
                                                disabled={isLoading}
                                                style={{ width: '130px' }}
                                            >
                                                {isLoading && <Spinner
                                                    size="sm"
                                                ></Spinner>}
                                                <span className="ms-1">{t("Button Create Post")}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </form>
                </ModalBody>
            </Modal>

        </React.Fragment >
    );
};

export default ModalPostArticle;